import clsx from 'clsx';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { tv } from 'tailwind-variants';

const buttonStyles = tv({
  base: `bg-white px-2 text-gray-700 underline decoration-1 transition-opacity`,
  variants: {
    expanded: {
      true: '-translate-y-1 opacity-75',
      false: '-translate-y-6',
    },
  },
});

export const ExpandableContent = ({
  children,
  ...props
}: React.ComponentProps<'div'>) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div {...props}>
      <p
        className={clsx(
          'overflow-hidden transition-all duration-500 ease-in-out',
          {
            'max-h-screen': isExpanded,
            'line-clamp-3 max-h-20': !isExpanded,
          }
        )}
      >
        {children}
      </p>

      <div className="flex justify-end">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={buttonStyles({ expanded: isExpanded })}
        >
          {isExpanded ? t('Show Less') : `... ${t('Show More')}`}
        </button>
      </div>
    </div>
  );
};
